export default "__VITE_ASSET__7GLWlX6V__"